export class AppNotificationModel {
    public constructor(
        public type: AppNotificationType,
        public titleText: string,
        public bodyText: string,
        public okaction?: () => void,
    ) {}
}

export enum AppNotificationType {
    INFO,
    WARN,
    ERROR,
}
